import { ComponentType, FC } from 'react';
import { useIsSmallScreen } from 'hooks/search/useIsBreakpointScreen';

export type WithIsSmallScreenProps = {
  isSmallScreen: boolean;
};

export const withIsSmallScreen = <P extends object>(WrappedComponent: ComponentType<P>): FC<P> => {
  const WrappedWithIsSmallScreen = (props: P) => {
    const isSmallScreen = useIsSmallScreen();
    return <WrappedComponent isSmallScreen={isSmallScreen} {...props} />;
  };

  const componentName = WrappedComponent.displayName || WrappedComponent.name || 'WrappedComponent';
  WrappedWithIsSmallScreen.displayName = `WithIsSmallScreen(${componentName})`;

  return WrappedWithIsSmallScreen;
};
